export const getUrlPhoto = (img: string): string => {
  return img.includes('https://') 
    ? img + '?' + Math.random()
    : img
}